<template>
  <div id="app">
    <transition name="transition-1" mode="out-in">
      <RouterView />
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',

  computed: {
    ...mapState('auth', [
      'isSignIn',
      'userProfile'
    ])
  },

  methods: {
    ...mapMutations('auth', [
      'SET_IS_AUTH_INIT',
      'SET_IS_SIGN_IN',
      'SET_USER_PROFILE'
    ]),

    sessionValidate () {
      const requiresAuth = this.$route.matched.some(item => item.meta.requiresAuth)

      if (requiresAuth) {
        if (this.isSignIn) {
          this.userProfileRefresh()
        } else {
          this.$router.push({ name: 'login' })
        }
      } else if (this.isSignIn) {
        this.$router.push({ name: 'access-management' })
      }
    },

    userProfileRefresh () {
      const userProfile = this.$gAuth.GoogleAuth.currentUser.get().getBasicProfile()

      if (!this.userProfile) {
        this.SET_USER_PROFILE(userProfile)
      }
    }
  },

  watch: {
    $route () {
      this.sessionValidate()
    }
  },

  created () {
    const checkAuthLoad = setInterval(() => {
      if (this.$gAuth.isInit) {
        clearInterval(checkAuthLoad)

        this.SET_IS_AUTH_INIT()
        this.SET_IS_SIGN_IN(this.$gAuth.isAuthorized)

        this.sessionValidate()
      }
    }, 500)
  }
}
</script>

<style lang="scss">
  @import '~@/styles/main.scss';
</style>
